<template>
  <div class="rightModel">
    <div class="ai-menu" @click="showAI">
      <img src="@/assets/img/ai-icon.png" />
      <span>AI小智</span>
    </div>
    <div class="userInfo">
      <el-dropdown @command="handleCommand" placement='bottom'>
        <span class="name">{{ userInfo.userName }}
          <span class="iconfont icon-icon_intelli_list_jiantou jiantou"></span>
        </span>

        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command='1'>
            <p class="p-item">
              <icon name="icon-xiugaimima"></icon>
              <span>修改密码</span>
            </p>
          </el-dropdown-item>
          <el-dropdown-item command='2'>
            <p class="p-item">
              <icon name="icon-tuichu"></icon>
              <span>退出登录</span>
            </p>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <UpdatePassword :showDialog="showDialog" @closeDialog="showDialog = false"></UpdatePassword>

    <el-drawer custom-class="ai-drawer" :with-header="false" :visible.sync="drawerVisible" destroy-on-close
      title="AI小智">
      <iframe class="ai-iframe" :src="aiUrl"></iframe>
    </el-drawer>
  </div>
</template>

<script>
import UpdatePassword from '@/views/userInfo/UpdatePassword.vue'
export default {
  name: 'User',
  components: {
    UpdatePassword
  },
  data() {
    return {
      showDialog: false,
      userName: '',
      drawerVisible: false,
      token: '',
      botId: ''
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    aiUrl() {
      const params = this.$qs.stringify({
        token: this.$store.state.token,
        customerCode: this.$store.state.customer,
        redirect: encodeURIComponent('/pages/agent/Agent')
      })
      return `${window.location.origin}/jgh5/uniappv3/pages/loading/Loading?` + params
    }
  },
  watch: {
  },
  created() {
    this.loadToken().then(() => {
      this.chatInit()
    })
  },
  methods: {
    // 下拉点击事件
    handleCommand(v) {
      if (v === '1') {
        this.showDialog = true
      } else if (v === '2') {
        this.loginOut()
      }
    },
    loginOut() {
      this.$axios.post(this.$apis.common.logout).then(() => {
        this.$store.commit('logout')
        this.$router.push('/login')
        this.$message.success('退出成功')
      })
    },
    loadToken() {
      return this.$axios.get(this.$apis.common.getJwtAccessToken).then(res => {
        this.token = res.accessToken
        this.botId = res.botId
        return res
      })
    },
    showAI() {
      this._cozeWebSDK.showChatBot()
    },
    chatInit() {
      this._cozeWebSDK = new CozeWebSDK.WebChatClient({
        config: {
          bot_id: this.botId,
          isIframe: false
        },
        auth: {
          type: 'token',
          token: this.token,
          onRefreshToken: async () => {
            const res = await this.loadToken()
            return res.accessToken
          }
        },
        userInfo: {
          id: this.userInfo.userId,
          url: 'https://qn.base.file.gintell.cn/icon/jg/user.png',
          nickname: this.userInfo.userName
        },
        ui: {
          base: {
            lang: 'zh-CN',
            icon: 'https://qn.base.file.gintell.cn/icon/jg/ai-logo.jpeg'
          },
          header: {
            isShow: true,
            isNeedClose: true
          },
          asstBtn: {
            isNeed: false
          },
          footer: {
            isShow: false
          },
          chatBot: {
            title: 'AI小智'
          }
        }
      })
    }
  }
}
</script>

<style lang="scss">
.ai-drawer {
  width: 460px !important;
}
</style>
<style scoped lang="scss">
.p-item {
  display: flex;
  align-items: center;

  span {
    margin-left: 4px;
  }
}

.ai-iframe {
  width: 100%;
  height: 100%;
  border: none;
  vertical-align: top;
}

.ai-menu {
  display: flex;
  align-items: center;
  margin-right: 20px;
  cursor: pointer;

  img {
    margin-right: 10px;
  }

  span {
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 6rpx;
    color: #FFFFFF;
    line-height: 9rpx;
    text-align: left;
    font-style: normal;
  }
}

.rightModel {
  display: flex;
  align-items: center;

  .setting {
    padding: 0 20px;
    cursor: pointer;

    .iconfont {
      color: #ffffff;
    }
  }

  .userInfo {
    margin-right: 20px;
    cursor: pointer;

    .name {
      display: flex;
      align-items: center;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 6rpx;
      color: #FFFFFF;
      line-height: 9rpx;
      text-align: left;
      font-style: normal;
    }

    .el-dropdown {
      display: flex;
      align-items: center;
    }

    .jiantou {
      height: 6px;
      color: #ffffff;
      font-size: 6px;
      margin-left: 6px;
    }
  }
}
</style>
